import { dateToX, COLORS, HEADER_HEIGHT } from './calendarConstants';

export function TodayMarker({ today, rangeStart, totalHeight }) {
  const x = dateToX(today, rangeStart);
  return (
    <div className="absolute top-0 z-20 pointer-events-none"
      style={{ left: x, width: 2, height: totalHeight, backgroundColor: COLORS.todayLine, opacity: 0.6 }}>
      <div className="absolute left-1/2 -translate-x-1/2 px-1.5 py-0.5 rounded text-[9px] font-semibold text-white whitespace-nowrap"
        style={{ backgroundColor: COLORS.todayLine, top: HEADER_HEIGHT + 2, opacity: 1 }}>
        Today
      </div>
    </div>
  );
}
